module.exports = __webpack_public_path__ + "static/bubble-27a2d64c2b927a2b5365842096813790.wav";